import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { useGlobalStore } from '../../../../store'
import forumService from '../../../../services/forum.service'
import { useReactQuery } from '../../../../hooks/useReactQuery'
import { MuiSelect, MuiTextField, AccordionWithArrow, MessageReactQuery } from '../../../../components'
import { convertStringToSelectArray, defaultSelectObj } from '../../../../util'

const ItemMarketResearchQuestions = ({ data, mode, onChange, expanded }) => {
  const { company } = useGlobalStore()

  const [formSectionData, setFormSectionData] = useState([])
  const [formSelectData, setFormSelectData] = useState({ question: [] })

  const onChangeHandler = (key, value) => {
    const obj = formSectionData
    obj[key] = value
    setFormSectionData(obj)
    onChange(obj)
  }

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['AggregationQuestions'],
      urlFunc: forumService.getOrganizationAggregationQuestionFuncApi,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)

  // const onload = async () => {
  //   const payload = { organizationId: company?.OrganizationId }
  //   const questionApi = await forumService.getOrganizationAggregationQuestionFuncApi(payload)
  //   const data = []
  //   for (let i = 0; i < questionApi.length; i++) {
  //     if (i === 7 || i === 8 || i === 9) {
  //       data.push('')
  //     } else {
  //       const array = questionApi[i].length > 0 ? [defaultSelectObj.empty, ...convertStringToSelectArray(questionApi[i])] : [defaultSelectObj.empty]
  //       data.push(array)
  //     }
  //   }
  //   setFormSelectData(data)
  // }

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value?.length > 0) && mode }
    return true
  }

  useEffect(() => {
    const obj = {}
    for (let i = 1; i <= 15; i++) {
      obj[`Question${i}`] = data[`Question${i}`] || ''
    }
    setFormSectionData(obj)
  }, [formSelectData])

  // useEffect(() => {
  //   onload()
  // }, [])

  useEffect(() => {
    onChange(formSectionData)
  }, [formSectionData])

  const onSuccess1Func = (resp) => {
    const data = []
    for (let i = 0; i < resp.length; i++) {
      if (i === 7 || i === 8 || i === 9) {
        data.push('')
      } else {
        const array = resp[i].length > 0 ? [defaultSelectObj.empty, ...convertStringToSelectArray(resp[i])] : [defaultSelectObj.empty]
        data.push(array)
      }
    }
    setFormSelectData(data)
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  return (
    <AccordionWithArrow title='Item Market Research Questions' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
      <MessageReactQuery
        isLoading={isLoading1}
        isSuccess={isSuccess1}
        data={data1}
        isError={isError1}
        error={error1}
      />
      <Grid container spacing={2}>
        {(Object.keys(formSectionData)).map((key, index) => {
          const i = index + 1
          if (!hasDataAndNotDisabled(formSectionData[key])) return false
          // consoleLog('formSelectData = ', formSelectData)
          return (
            <Grid item xs={4} key={'itemMarketResearch__' + i}>
              { [8, 9, 10].includes(i)
                ? <MuiTextField
                    name={key}
                    // label={`Question ${i}`}
                    placeholder={`Question ${i}`}
                    onChange={(e) => onChangeHandler(key, e.target.value)}
                    variant='standard'
                    value={formSectionData[key] || ''}
                    disabled={mode}
                  />
                : <>{formSelectData[i - 1]?.length > 0 && <MuiSelect
                    data={formSelectData[i - 1]}
                    name={key}
                    // label={`Question ${i}`}
                    placeholder={`Question ${i}`}
                    onChange={(e) => onChangeHandler(key, e.target.value)}
                    variant='standard'
                    value={formSectionData[key] || ''}
                    disabled={mode}
                  />}</>
              }
            </Grid>
          )
        })}
      </Grid>
    </AccordionWithArrow>
  )
}

ItemMarketResearchQuestions.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default ItemMarketResearchQuestions
